import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3911242a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-selectApprove" }
const _hoisted_2 = { class: "uf-selectApprove__next" }
const _hoisted_3 = { class: "uf-selectApprove__type" }
const _hoisted_4 = {
  class: "uf-staff-selector",
  style: {"flex":"1","overflow":"auto"}
}
const _hoisted_5 = { class: "uf-staff-selector__inner" }
const _hoisted_6 = {
  key: 1,
  class: "uf-staff-selector__inner-avatar2"
}
const _hoisted_7 = { class: "uf-staff-selector__info" }
const _hoisted_8 = { class: "uf-staff-selector__info-name" }
const _hoisted_9 = { class: "uf-staff-selector__info-other" }
const _hoisted_10 = { class: "uf-button" }
const _hoisted_11 = { class: "uf-button--footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_choose_person = _resolveComponent("choose-person")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: _ctx.popupShow,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.popupShow) = $event)),
      position: "right",
      style: {
        height: '100%',
        width: '100%',
        background: '#f6f7fa',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_nav_bar, {
          title: "选择人员",
          "left-text": "返回",
          "left-arrow": "",
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupShow = false))
        }),
        _createElementVNode("div", _hoisted_2, "下级节点：" + _toDisplayString(_ctx.info.next_node_name), 1),
        _createElementVNode("div", _hoisted_3, [
          _createTextVNode(" 审批方式：" + _toDisplayString(_ctx.info.approval_way_type_name) + " ", 1),
          (_ctx.info.approval_way_type === 1)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" （至少" + _toDisplayString(_ctx.info.user_num) + "人） ", 1)
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.info.user_info.length === 0)
            ? (_openBlock(), _createBlock(_component_van_empty, {
                key: 0,
                class: "custom-image",
                image: require('../assets/empty@2x.png'),
                description: "暂无节点审批人"
              }, null, 8, ["image"]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.info.user_info, (user) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "uf-staff-selector__item",
                  key: user.id
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    (user.head_pic)
                      ? (_openBlock(), _createBlock(_component_van_image, {
                          key: 0,
                          round: "",
                          width: "40px",
                          height: "40px",
                          src: user.head_pic,
                          class: "uf-staff-selector__inner-avatar"
                        }, null, 8, ["src"]))
                      : _createCommentVNode("", true),
                    (!user.head_pic)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(user.name[0]), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(user.name), 1),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(user.department_name || user.from_name) + " - " + _toDisplayString(user.duty_name), 1)
                    ])
                  ])
                ]))
              }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.info.power_approval_type === 0)
              ? (_openBlock(), _createBlock(_component_van_button, {
                  key: 0,
                  plain: "",
                  class: "btn",
                  square: "",
                  type: "primary",
                  onClick: _ctx.select,
                  style: {"margin-right":"10px"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("添加审批人 ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_van_button, {
              class: "btn",
              color: "#3d6eeb",
              square: "",
              type: "success",
              onClick: _ctx.submit
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交 ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_choose_person, {
      show: _ctx.choosePersonShow,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.choosePersonShow) = $event)),
      multiple: "",
      onConfirm: _ctx.confirm
    }, null, 8, ["show", "onConfirm"])
  ]))
}